<div class="col-card" [class.deleted]="collaboration.deleted">
  <div class="col-row">
    <div class="col-dir" [class.sent]="sent" [class.received]="!sent">
      <svg
        *ngIf="sent"
        width="13"
        height="13"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z" />
      </svg>
      <svg *ngIf="!sent" width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
        <path d="M15 5v2H8.41L20 18.59 18.59 20 7 8.41V15H5V5z" />
      </svg>
    </div>
    <div class="col-info">
      <div class="col-title" [class.deleted]="collaboration.deleted">
        <app-activity-event-icon
          [iconKind]="categoryKind"
          tone="info"
          [label]="category"
        ></app-activity-event-icon>
        {{ collaboration.title }}
        <span class="chip chip-def category-chip" *ngIf="collaboration.category">{{ category }}</span>
      </div>
      <div class="col-sub">
        <span>{{ sent ? '→ Enviada' : '← Recibida' }}</span>
        <span>·</span>
        <span>{{ documentCount }} docs · {{ commentCount }} {{ commentLabel }}</span>
      </div>
    </div>
    <div class="col-right">
      <span class="chip" [ngClass]="'chip-' + statusMeta.cssClass">{{ statusMeta.text }}</span>
      <app-tx-link [txHash]="txHash" [explorerUrl]="collaboration.explorerUrl"></app-tx-link>
      <span
        class="col-date"
        [matTooltip]="lastDateTime"
        matTooltipPosition="above"
      >{{ lastDate }}</span>
    </div>
    <button class="toggle-btn" type="button" [attr.aria-expanded]="expanded" (click)="toggle()">
      Detalle
      <span class="expand-icon" [class.open]="expanded">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
          <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
        </svg>
      </span>
    </button>
  </div>

  <div class="col-detail" *ngIf="expanded">
    <div class="loading-note" *ngIf="loadingMember">Cargando datos del miembro…</div>
    <ng-container *ngIf="!loadingMember">
      <div class="detail-row" *ngIf="otherMemberName">
        <span class="detail-label">{{ sent ? 'Enviada a' : 'Recibida de' }}</span>
        <span class="detail-value">{{ otherMemberName }}</span>
      </div>
      <ng-container *ngIf="member">
        <div class="detail-row" *ngIf="otherMemberType">
          <span class="detail-label">Tipo</span>
          <span class="detail-value">{{ otherMemberType }}</span>
        </div>
        <div class="detail-row" *ngIf="otherMemberCommunities">
          <span class="detail-label">Comunidades</span>
          <span class="detail-value">{{ otherMemberCommunities }}</span>
        </div>
      </ng-container>
      <div class="loading-note" *ngIf="canResolveMember && !member">
        No se pudieron obtener los datos del miembro.
      </div>
    </ng-container>
  </div>
</div>
